import React, { useEffect, useState, useCallback } from "react";
import DashboardLayout from "../../../layouts/DashboardLayout/DashboardLayout";
import {
  Box,
  Card,
  CardMedia,
  Divider,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import typographyStyles from "../../../theme/Typography";
import BasicButtons from "../../../components/Button";
import Dropdown from "../../../components/Dropdown";
import InputField from "../../../components/InputField";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import {
  addCategorySchema,
  addNewCategorySchema,
  editBlogsSchema,
  editCategorySchema,
} from "../../../schema";
import {
  getCategoryWithToken,
  postDataHandler,
  postDataHandlerWithToken,
} from "../../../apiconfig/service";
import toast from "react-hot-toast";
import "../../../scss/main.css";
import backBtn from "../../../assets/backBtn.svg";
import Cropper from "react-easy-crop";
import ReactModal from "react-modal";
import { getCroppedImg } from "../../../utils/cropImage";
import { modalStyles } from "../../../scss/style";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor,
  AccessibilityHelp,
  Alignment,
  Autoformat,
  AutoLink,
  Autosave,
  BlockQuote,
  Bold,
  CodeBlock,
  Essentials,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  GeneralHtmlSupport,
  Heading,
  HorizontalLine,
  Indent,
  IndentBlock,
  Italic,
  Link,
  Paragraph,
  SelectAll,
  Style,
  Table,
  TableCaption,
  TableCellProperties,
  TableColumnResize,
  TableProperties,
  TableToolbar,
  TextTransformation,
  Underline,
  List,
  ListProperties,
  Undo,
} from "ckeditor5";

// Styles for the modal and cropping area
const addEditStyle = {
  addEditTitle: {
    ...typographyStyles.h4,
  },
  addEditLabel: {
    ...typographyStyles.h6,
  },
  radioContainer: {
    display: "flex",
  },
};

const dropdownOptions = [
  "Trying to Conceive",
  "Pregnant",
  "Postpartum (0-6 Weeks After Birth)",
  "Beyond -(6 Weeks + After Birth (Weeks, months, Years))",
  "Babies and Kids", 
];


const se = [
  { key: "Trying to Conceive", value: "TRYINGTOCONCEIVE" },
  { key: "Pregnant", value: "PREGNANT" },
  { key: "Postpartum (0-6 Weeks After Birth)", value: "POSTPARTUM" },
  {
    key: "Beyond -(6 Weeks + After Birth (Weeks, months, Years))",
    value: "BEYOND",
  },
  { key: "Babies and Kids", value: "BABIESANDKIDS" }, // New object added
];

const blogConfig = {
  toolbar: {
    items: [
      "undo",
      "redo",
      "|",
      "heading",
      "style",
      "|",
      "fontSize",
      "fontFamily",
      "fontColor",
      "fontBackgroundColor",
      "|",
      "bold",
      "italic",
      "underline",
      "bulletedList",
      "numberedList",

      "|",
      "horizontalLine",
      "link",
      "insertTable",
      "blockQuote",
      "codeBlock",
      "|",
      "alignment",
      "|",
      "outdent",
      "indent",
    ],
    shouldNotGroupWhenFull: false,
  },
  plugins: [
    AccessibilityHelp,
    Alignment,
    Autoformat,
    AutoLink,
    Autosave,
    BlockQuote,
    Bold,
    CodeBlock,
    Essentials,
    FontBackgroundColor,
    FontColor,
    FontFamily,
    FontSize,
    GeneralHtmlSupport,
    Heading,
    HorizontalLine,
    Indent,
    IndentBlock,
    Italic,
    Link,
    Paragraph,
    SelectAll,
    List,
    ListProperties,

    TextTransformation,
    Underline,
    Undo,
  ],
  fontFamily: {
    supportAllValues: true,
  },
  fontSize: {
    options: [10, 12, 14, "default", 18, 20, 22],
    supportAllValues: true,
  },
  heading: {
    options: [
      {
        model: "paragraph",
        title: "Paragraph",
        class: "ck-heading_paragraph",
      },
      {
        model: "heading1",
        view: "h1",
        title: "Heading 1",
        class: "ck-heading_heading1",
      },
      {
        model: "heading2",
        view: "h2",
        title: "Heading 2",
        class: "ck-heading_heading2",
      },
      {
        model: "heading3",
        view: "h3",
        title: "Heading 3",
        class: "ck-heading_heading3",
      },
      {
        model: "heading4",
        view: "h4",
        title: "Heading 4",
        class: "ck-heading_heading4",
      },
      {
        model: "heading5",
        view: "h5",
        title: "Heading 5",
        class: "ck-heading_heading5",
      },
      {
        model: "heading6",
        view: "h6",
        title: "Heading 6",
        class: "ck-heading_heading6",
      },
    ],
  },
  htmlSupport: {
    allow: [
      {
        name: /^.*$/,
        styles: true,
        attributes: true,
        classes: true,
      },
    ],
  },

  link: {
    addTargetToExternalLinks: true,
    defaultProtocol: "https://",
    decorators: {
      toggleDownloadable: {
        mode: "manual",
        label: "Downloadable",
        attributes: {
          download: "file",
        },
      },
    },
  },
  placeholder: "Type or paste your content here!",
};

const AddBlog = () => {

  const [categoryType, setCategoryType] = useState("FREE");
  const [thumbnail, setThumbnail] = useState(null);
  const [thumbnailPreview, setThumbnailPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [newImageSelected, setNewImageSelected] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [categoryId, setCategoryId] = useState(location?.state?.categoryId);

  const {
    values,
    errors,
    handleBlur,
    handleChange,
    touched,
    handleSubmit,
    setValues,
    setFieldValue
  } = useFormik({
    initialValues: {
      blogTitle: "",
      blogTag: "",
      blogDescription: "",
      thumbnail:"",
    },
    validationSchema: editBlogsSchema,

    onSubmit: async (values) => {
      const formData = new FormData();
      if (newImageSelected) {
        formData.append("file", croppedImage);
      }
      try {
        setLoading(true);
        let imageUploadResult = null;
        if (newImageSelected) {
          imageUploadResult = await postDataHandler("uploadFile", formData);
          if (imageUploadResult.responseCode !== 200) {
            console.log("Error while uploading file");
            return;
          }
        }
        const res = await postDataHandlerWithToken("addUpdateBlog", {
          categoryId: categoryId,
          title: values.blogTitle,
          tag:values.blogTag,
          description:values.blogDescription,
          thumbnail: newImageSelected ? imageUploadResult.result : thumbnail,
        });

        if (res.responseCode === 200) {
          toast.success(res.responseMessage);
          navigate("/staticcontent/listBlogs/viewBlogs" ,{ state: { statisticsData : {_id : location?.state?.categoryId} }});
        } else {
          toast.error(res.data.responseMessage);
        }
      } catch (error) {
        console.error("Failed to add Blog:", error);
      } finally {
        setLoading(false);
      }
    },
  });

  const handleDropdownChange = (value) => {
    setValues({ ...values, selectStage: value });
  };

  const handleCategoryTypeChange = (event) => {
    setCategoryType(event.target.value);
  };

  const handleThumbnailChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(URL.createObjectURL(file));
      setIsModalOpen(true);
      setNewImageSelected(true); // Mark new image as selected
    }
  };

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleCrop = useCallback(async () => {
    try {
      const croppedImageBlob = await getCroppedImg(
        selectedImage,
        croppedAreaPixels
      );
      setCroppedImage(croppedImageBlob);
      setThumbnailPreview(URL.createObjectURL(croppedImageBlob));
      setThumbnail(croppedImageBlob);
      setIsModalOpen(false);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels, selectedImage]);

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
    setCroppedImage(null);
    setThumbnailPreview(thumbnail); // Revert to the original thumbnail if canceling
    setNewImageSelected(false); // Mark new image as not selected
  };

  return (
    <DashboardLayout sectionName="Add Blog" title="Add Blog">
      <Box className="heading-container-top">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Box>
            <img
              src={backBtn}
              alt="backBtn"
              style={{
                cursor: "pointer",
              }}
              onClick={() => navigate(-1)}
            />
          </Box>
          <Typography sx={{ ...typographyStyles.h4 }}>Add Blog</Typography>
        </Box>
      </Box>
      <Divider />
      <Box className="add-edit-container">
        <form className="add-edit-content-section" onSubmit={handleSubmit}>
          <Box className="add-edit-content">
            <Box className="add-edit-input-container">
              <Box className="add-edit-input-label">
                <Typography sx={addEditStyle.addEditLabel}>
                  Blog Title:
                </Typography>
              </Box>
              <Box className="add-edit-input-field">
                <InputField
                  type="text"
                  name="blogTitle"
                  value={values.blogTitle}
                  maxLength={50}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter Blog Title"
                />
                {errors.blogTitle && touched.blogTitle ? (
                  <p style={{ color: "red", marginTop: "2px", float: "left" }}>
                    {errors.blogTitle}
                  </p>
                ) : null}
              </Box>
            </Box>
            <Box className="add-edit-input-container">
              <Box className="add-edit-input-label">
                <Typography sx={addEditStyle.addEditLabel}>
                  Blog Tag:
                </Typography>
              </Box>
              <Box className="add-edit-input-field">
                <InputField
                  type="text"
                  name="blogTag"
                  value={values.blogTag}
                  maxLength={50}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter Blog Tag"
                />
                {errors.blogTag && touched.blogTag ? (
                  <p style={{ color: "red", marginTop: "2px", float: "left" }}>
                    {errors.blogTag}
                  </p>
                ) : null}
              </Box>
            </Box>
            <Box className="add-edit-input-container">
              <Box className="add-edit-input-label">
                <Typography sx={addEditStyle.addEditLabel}>
                  Blog Description:
                </Typography>
              </Box>
              <Box
                className="add-edit-input-field ckeditor-container"
                sx={{ width: "100%" }}
              >
                <CKEditor
                  editor={ClassicEditor}
                  data={values.blogDescription}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setFieldValue("blogDescription", data);
                  }}
                  config={blogConfig}
                />
                {errors.blogDescription && touched.blogDescription ? (
                  <p style={{ color: "red", marginTop: "2px" }}>
                    {errors.blogDescription}
                  </p>
                ) : null}
              </Box>
            </Box>
            {/* <Box className="add-edit-input-container">
              <Box className="add-edit-input-label">
                <Typography sx={addEditStyle.addEditLabel}>Save As:</Typography>
              </Box>
              <Box className="add-edit-input-field">
                <FormControl component="fieldset">
                  <RadioGroup
                    name="categoryType"
                    value={categoryType}
                    onChange={handleCategoryTypeChange}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <FormControlLabel
                      className="radio"
                      value="FREE"
                      control={<Radio />}
                      label="Free"
                    />
                    <FormControlLabel
                      className="radio"
                      value="LOCKED"
                      control={<Radio />}
                      label="Locked (will be accessed after subscription)"
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
            </Box> */}
            <Box className="add-edit-input-container">
              <Box className="add-edit-input-label">
                <Typography sx={addEditStyle.addEditLabel}>
                  Thumbnail:
                </Typography>
              </Box>
              <Box className="add-edit-input-field">
                <InputField
                  type="file"
                  name="categoryImage"
                  onBlur={handleBlur}
                  onChange={handleThumbnailChange}
                  acceptedFile="image/*"
                />
                {thumbnailPreview && (
                  <Box mt={2}>
                    <Card sx={{ maxWidth: 300, maxHeight: "auto" }}>
                      <CardMedia component="img" image={thumbnailPreview} />
                    </Card>
                  </Box>
                )}
                {errors.categoryImage && touched.categoryImage ? (
                  <p style={{ color: "red", marginTop: "2px", float: "left" }}>
                    {errors.categoryImage}
                  </p>
                ) : null}
              </Box>
            </Box>
          </Box>
          <Box
            className="add-edit-button-section"
            sx={{ alignItems: "center", justifyContent: "center" }}
          >
            <BasicButtons
              text={"Add Blog"}
              disabled={loading}
              name="submit"
              type="submit"
              loading={loading}
              width={"20%"}
            />
          </Box>
        </form>
      </Box>
      {/* Image Cropping Modal */}
      <ReactModal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        style={modalStyles}
        contentLabel="Crop Image Modal"
      >
        <Box sx={{ position: "relative", height: "100%" }}>
          <Cropper
            image={selectedImage}
            crop={crop}
            zoom={zoom}
            aspect={17 / 12} // Set the aspect ratio as required
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
          />
          <Box
            sx={{
              position: "absolute",
              bottom: 0,
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              p: 2,
              gap: 5,
            }}
          >
            <BasicButtons text="Cancel" onClick={handleCancel} />
            <BasicButtons text="Crop" onClick={handleCrop} />
          </Box>
        </Box>
      </ReactModal>
    </DashboardLayout>
  );
};

export default AddBlog;
